import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Gallery from './components/Gallery';
import Features from './components/Features';
import About from './components/About';
import Footer from './components/Footer';

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-dark font-body text-ink antialiased">
        <Header />
        <Hero />
        <Stats />
        <Gallery />
        <Features />
        <About />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
